import { MessageSquare, FileText, Palette, Hammer } from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      icon: MessageSquare,
      title: 'Consultation',
      description:
        'We begin with a complimentary consultation to understand your vision, preferences, and how you use your space. This helps us create a tailored approach for your project.',
    },
    {
      number: '02',
      icon: FileText,
      title: 'Design Proposal',
      description:
        'Based on our discussion, we prepare a detailed design proposal including concept boards, material recommendations, and a transparent cost estimate.',
    },
    {
      number: '03',
      icon: Palette,
      title: 'Material Selection',
      description:
        'Together, we select the perfect materials, fabrics, and finishes. We provide samples and ensure every choice aligns with your vision and budget.',
    },
    {
      number: '04',
      icon: Hammer,
      title: 'Professional Installation',
      description:
        'Our experienced team handles all implementation with care and precision. We maintain clear communication throughout and ensure your complete satisfaction.',
    },
  ];

  return (
    <section
      data-testid="process-section"
      className="section-padding bg-[#FAF9F6] relative overflow-hidden"
    >
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#F0EBE0] to-transparent opacity-50" />

      <div className="container-main relative">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-xs uppercase tracking-[0.3em] text-[#C5A065] mb-4 block">
            How We Work
          </span>
          <h2
            data-testid="process-title"
            className="font-heading text-3xl md:text-4xl text-[#2D2D2D] mb-6"
          >
            Our Transparent Process
          </h2>
          <p className="text-[#6E6E6E] leading-relaxed">
            We believe in clear communication and structured workflows. Here's
            how we transform your space from concept to completion.
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              data-testid={`process-step-${index}`}
              className="relative"
            >
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-px bg-[#E5E0D8] -translate-x-4" />
              )}

              <div className="relative">
                {/* Step Number */}
                <span className="font-heading text-6xl text-[#E5E0D8] absolute -top-4 -left-2">
                  {step.number}
                </span>

                <div className="pt-12">
                  <div className="w-14 h-14 rounded-full bg-white shadow-lg flex items-center justify-center mb-6">
                    <step.icon className="w-6 h-6 text-[#C5A065]" />
                  </div>

                  <h3 className="font-heading text-xl text-[#2D2D2D] mb-4">
                    {step.title}
                  </h3>

                  <p className="text-[#6E6E6E] text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
